import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ItemUnitTypesEnum } from '../../../item-data/item-data.data';
import { LocalizationService } from '../../../localization/localization.service';

@Injectable()
export class DocumentItemsListItemBuilder {
  constructor(
    private _translateService: TranslateService,
    private _localizationService: LocalizationService
  ) {}

  buildQuantityRate(
    quantity: number,
    unitType: ItemUnitTypesEnum,
    locale: string
  ) {
    const decimalSeparator = this._localizationService.getDecimalSeparator(
      locale
    );
    const formattedQty = quantity.toString().replace('.', decimalSeparator);

    switch (unitType) {
      case ItemUnitTypesEnum.labor_days:
        return quantity === 1
          ? this._translateService.instant('DATE.ONE_DAY')
          : this._translateService.instant('DATE.N_DAYS', {
              number: formattedQty,
            });
      case ItemUnitTypesEnum.labor_hours:
        return quantity === 1
          ? this._translateService.instant('DATE.ONE_HOUR')
          : this._translateService.instant('DATE.N_HOURS', {
              number: formattedQty,
            });
      default:
        return `${formattedQty}`;
    }
  }
}
